import { defineComponent as _defineComponent } from 'vue'
import { inject, ref, Ref } from 'vue';

import { NavBar, ButtonIconContextual } from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { SelectedProductList } from './components/SelectedProductList';

import { EProductsAcquisitionSteps } from '@/modules/catalog/views/ProductsAcquisition/helpers';

import { IProductGetLastState } from '@/modules/catalog/services/products-acquisition';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductReview',
  setup(__props) {

const productList = inject('productList') as Ref<IProductGetLastState[]>;

const changeStep = inject('changeStep', (step: EProductsAcquisitionSteps) => ({
  step
}));

const isDeleteMode = ref(false);

function handleDeleteMode() {
  isDeleteMode.value = !isDeleteMode.value;
}

return { __sfc: true,productList, changeStep, isDeleteMode, handleDeleteMode, NavBar, ButtonIconContextual, BackButton, SelectedProductList, EProductsAcquisitionSteps }
}

})